import { render, staticRenderFns } from "./simplified-paycheck-template.vue?vue&type=template&id=6e80caf6&scoped=true&"
import script from "./simplified-paycheck-template.vue?vue&type=script&lang=ts&"
export * from "./simplified-paycheck-template.vue?vue&type=script&lang=ts&"
import style0 from "./simplified-paycheck-template.vue?vue&type=style&index=0&id=6e80caf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e80caf6",
  null
  
)

export default component.exports